module.exports = __webpack_public_path__ + "static/img/o9m1.6c9ee42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/o9m/o9m1.jpg
// module id = WsWP
// module chunks = 1